import type { Event } from '@patsnap/tahiti-core';
import type { SpecificationFigure } from '../types/specification-figures';

export interface SpecificationFiguresServiceState {
    figures: SpecificationFigure[];
    currentIndex: number;
}

export const SpecificationFiguresService = Symbol.for('SpecificationFiguresService');

/**
 * 附图服务接口，负责管理说明书附图的增删改查及顺序、当前选中等状态。
 */
export interface SpecificationFiguresService {
    /**
     * 当前选中的附图索引。
     */
    readonly currentIndex: number;
    /**
     * 附图列表。
     */
    readonly figures: SpecificationFigure[];
    /**
     * 当前选中索引变更事件。
     * 监听此事件可响应当前选中附图的变化。
     */
    readonly onCurrentIndexChange: Event<number>;
    /**
     * 附图列表变更事件。
     * 监听此事件可响应附图的增删改动。
     */
    readonly onFiguresChange: Event<SpecificationFigure[]>;
    /**
     * 移除指定索引的附图。
     * @param index 要移除的附图索引
     */
    removeFigure(index: number): void;
    /**
     * 重新排序附图。
     * @param newOrder 附图 id 的新顺序数组
     */
    reorderFigures(newOrder: string[]): void;
    /**
     * 添加一张附图。
     * @param figure 附图对象
     */
    addFigure(figure: SpecificationFigure): void;
    /**
     * 设置当前选中的附图索引。
     * @param index 新的当前索引
     */
    setCurrentIndex(index: number): void;
    /**
     * 批量更新附图列表。
     * @param images 新的附图数组
     */
    updateFigures(images: SpecificationFigure[]): void;
    /**
     * 加载持久化的附图信息。
     */
    loadPersistedFigures(): Promise<void>;
}
